import { createContext } from "react";

const PaymentMethodsVolumetryForm = createContext({});

export default PaymentMethodsVolumetryForm;
